export default {
  api_r_open_impersonate: {
    path: 'imp/check/',
  },
};
